export function formatTime(iso: string | undefined, fallback = ''): string {
  if (!iso) return fallback;
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return fallback;
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return fallback;
  }
}

export function formatDateTime(iso: string | undefined, fallback = ''): string {
  if (!iso) return fallback;
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return fallback;
    return date.toLocaleString([], {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return fallback;
  }
}

export function formatRelativeTime(iso: string | undefined, fallback = ''): string {
  if (!iso) return fallback;
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return fallback;
    const delta = Date.now() - date.getTime();
    const abs = Math.abs(delta);

    const minutes = Math.round(abs / (1000 * 60));
    if (minutes < 1) return delta >= 0 ? 'just now' : 'in under a minute';
    if (minutes < 60) return delta >= 0 ? `${minutes}m ago` : `in ${minutes}m`;

    const hours = Math.round(minutes / 60);
    if (hours < 24) return delta >= 0 ? `${hours}h ago` : `in ${hours}h`;

    const days = Math.round(hours / 24);
    return delta >= 0 ? `${days}d ago` : `in ${days}d`;
  } catch {
    return fallback;
  }
}

export function formatDateCompact(iso: string | undefined, fallback = ''): string {
  if (!iso) return fallback;
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return fallback;
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
  } catch {
    return fallback;
  }
}

export function formatTimeCompact(iso: string | undefined, fallback = ''): string {
  if (!iso) return fallback;
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return fallback;
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
  } catch {
    return fallback;
  }
}

export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1)}…`;
}
